import { Button, Checkbox, Grid, TextField } from "@mui/material";
import { useEffect, useState, useContext } from "react";
import { Icon } from "@iconify/react";
import axios from "axios";
import BASE_URL from "../../../../../constants/baseUrls";
import { WithContext as ReactTags } from "react-tag-input";
import cookie from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";
import { LocaleContext } from "../../../../../routing/LangRouter";

import clsx from "clsx";
import { useDataFormValidator } from "../../validation/useDataFormValidator";

//general components
import BaseSelect from "../../../../../components/common/base-select/base-select";

import "./location-add.scss";

function LocationAdd() {
    const { locale } = useContext(LocaleContext);
    const navigate = useNavigate();
    const accessToken = localStorage.getItem("accessToken");

    //request get location list
    const [locationList, setLocationList] = useState(null);
    const getLocationList = async () => {
        const response = await axios.get(`${BASE_URL}/g5znsh6vtyic3w5/location/list/`, {
            params: {
                country: "",
                province: "",
                city: "",
                category: "",
            },
        });
        setLocationList(response.data.results);
    };
    useEffect(() => {
        getLocationList();
    }, []);

    //get location information
    let [searchParams, setSearchParams] = useSearchParams();
    const [isEditing, setIsEditing] = useState(false);
    const [locationInformation, setLocationInformation] = useState();
    const getLocationInformation = async () => {
        const response = await axios.get(`${BASE_URL}/g5znsh6vtyic3w5/location/info/`, {
            params: {
                pk: searchParams.get("id"),
                action: "viewLocation",
            },
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        setLocationInformation(response.data);
    };
    useEffect(() => {
        setIsEditing(searchParams.get("isEditing"));
        getLocationInformation();
    }, [searchParams]);

    const [baseInformation, setBaseInformation] = useState({
        id: "",
        name: "",
        english_name: "",
        address: "",
        location: "",
        description: "",
        text: "",
        avg_mins: "",
        extra_time: "",
        energy: "",
        extra_energy: "",
    });
    const { errors, validateForm, onBlurField } = useDataFormValidator(baseInformation);

    const handleChange = event => {
        // const { name, value } = event.target
        const value = event.target.value;
        const field = event.target.name;
        // setBaseInformation((values) => ({ ...values, [name]: value }))
        // setEditValues((values) => ({ ...values, [name]: value ? value : null }))

        // const field = e.target.name;
        // const value = e.target.value;
        const nextFormState = {
            ...baseInformation,
            [field]: value,
        };
        setBaseInformation(nextFormState);
        if (errors[field].dirty)
            validateForm({
                baseInformation: nextFormState,
                errors,
                field,
            });
    };

    //get country, province and city list
    const [countryList, setCountryList] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [provinceList, setProvinceList] = useState([]);
    const [selectedProvince, setSelectedProvince] = useState(null);
    const [cityList, setCityList] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);

    const getCountryList = async () => {
        const response = await axios.get(`${BASE_URL}/basic/countries/`);
        setCountryList(response.data.results);
        if (isEditing && locationInformation) {
            const country = response.data.results.find(item => item.id === locationInformation?.country);
            setSelectedCountry({ label: country.name, value: country.id });
        }
    };
    const getProvinceList = async () => {
        if (selectedCountry || isEditing) {
            const response = await axios.get(`${BASE_URL}/basic/provinces/`, {
                params: {
                    country: selectedCountry?.id,
                },
            });
            setProvinceList(response.data.results);
            if (locationInformation) {
                const provinceItem = response.data.results.find(pItem => pItem.id === locationInformation?.province);
                const label = provinceItem.name;
                const value = provinceItem.id;
                const province = {
                    label,
                    value,
                };
                setSelectedProvince(province);
            }
        }
    };
    const getCityList = async () => {
        if ((selectedCountry && selectedProvince) || isEditing || selectedCountry?.id !== 1) {
            const response = await axios.get(`${BASE_URL}/basic/cities/`, {
                params: {
                    country: selectedCountry?.id ?? locationInformation?.country,
                    province: selectedProvince?.id,
                    limit: "2000",
                },
            });
            setCityList(response.data.results);
            if (locationInformation) {
                const cityItem = response.data.results.find(cItem => cItem.id === locationInformation?.city);
                const label = cityItem.name;
                const value = cityItem.id;
                const city = {
                    label,
                    value,
                };
                setSelectedCity(city);
            }
        }
    };

    useEffect(() => {
        getCountryList();
        getProvinceList();
        if (!!locationInformation?.country) {
            getCityList();
        }
    }, [isEditing, locationInformation]);

    useEffect(() => {
        getProvinceList();
        if (selectedCountry?.id !== 1) {
            getCityList();
        }
    }, [selectedCountry]);

    useEffect(() => {
        if (!!selectedProvince) {
            getCityList();
            setSelectedCity(null);
        }
    }, [selectedProvince]);

    useEffect(() => {
        countryList.map(country => {
            Object.keys(country).forEach(keyItem => {
                if (keyItem === "id") {
                    country["value"] = country[keyItem];
                }
                if (keyItem === "name") {
                    country["label"] = country[keyItem];
                }
            });
            return country;
        });
        countryList?.map(country => {
            country.color = "#1E1E1E";
            return country;
        });

        provinceList.map(province => {
            Object.keys(province).forEach(keyItem => {
                if (keyItem === "id") {
                    province["value"] = province[keyItem];
                }
                if (keyItem === "name") {
                    province["label"] = province[keyItem];
                }
            });
            return province;
        });
        provinceList?.map(province => {
            province.color = "#1E1E1E";
            return province;
        });
        cityList.map(city => {
            Object.keys(city).forEach(keyItem => {
                if (keyItem === "id") {
                    city["value"] = city[keyItem];
                }
                if (keyItem === "name") {
                    city["label"] = city[keyItem];
                }
            });
            return city;
        });
        cityList?.map(city => {
            city.color = "#1E1E1E";
            return city;
        });
    }, [countryList, provinceList, cityList]);

    //get category
    const [categoryList, setCategoryList] = useState();
    const [selectedCategory, setSelectedCategory] = useState();
    const getCategoryList = async () => {
        const response = await axios.get(`${BASE_URL}/location/category/list/`);
        setCategoryList(response.data.results);
    };
    useEffect(() => {
        getCategoryList();
    }, []);
    useEffect(() => {
        categoryList?.map(category => {
            Object.keys(category).forEach(keyItem => {
                if (keyItem === "id") {
                    category["value"] = category[keyItem];
                }
                if (keyItem === "persian_name") {
                    category["label"] = category[keyItem];
                }
            });
            return category;
        });

        categoryList?.map(category => {
            category.color = "#1E1E1E";
            return category;
        });
    }, [categoryList]);

    //visit time
    const MONTH_NAMES = ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"];
    let monthIndex = 0;
    const weekDaysMap = {
        saturday: "شنبه",
        sunday: "یک شنبه",
        monday: "دوشنبه",
        tuesday: "سه شنبه",
        wednesday: "چهارشنبه",
        thursday: "پنج شنبه",
        friday: "جمعه",
        holiday: "تعطیلات رسمی",
    };
    const [times, setTimes] = useState({
        first_saturday: "",
        first_sunday: "",
        first_monday: "",
        first_tuesday: "",
        first_wednesday: "",
        first_thursday: "",
        first_friday: "",
        first_holiday: "",
        second_saturday: "",
        second_sunday: "",
        second_monday: "",
        second_tuesday: "",
        second_wednesday: "",
        second_thursday: "",
        second_friday: "",
        second_holiday: "",
        third_saturday: "",
        third_sunday: "",
        third_monday: "",
        third_tuesday: "",
        third_wednesday: "",
        third_thursday: "",
        third_friday: "",
        third_holiday: "",
        forth_saturday: "",
        forth_sunday: "",
        forth_monday: "",
        forth_tuesday: "",
        forth_wednesday: "",
        forth_thursday: "",
        forth_friday: "",
        forth_holiday: "",
        fifth_saturday: "",
        fifth_sunday: "",
        fifth_monday: "",
        fifth_tuesday: "",
        fifth_wednesday: "",
        fifth_thursday: "",
        fifth_friday: "",
        fifth_holiday: "",
        sixth_saturday: "",
        sixth_sunday: "",
        sixth_monday: "",
        sixth_tuesday: "",
        sixth_wednesday: "",
        sixth_thursday: "",
        sixth_friday: "",
        sixth_holiday: "",
        seventh_saturday: "",
        seventh_sunday: "",
        seventh_monday: "",
        seventh_tuesday: "",
        seventh_wednesday: "",
        seventh_thursday: "",
        seventh_friday: "",
        seventh_holiday: "",
        eighth_saturday: "",
        eighth_sunday: "",
        eighth_monday: "",
        eighth_tuesday: "",
        eighth_wednesday: "",
        eighth_thursday: "",
        eighth_friday: "",
        eighth_holiday: "",
        ninth_saturday: "",
        ninth_sunday: "",
        ninth_monday: "",
        ninth_tuesday: "",
        ninth_wednesday: "",
        ninth_thursday: "",
        ninth_friday: "",
        ninth_holiday: "",
        tenth_saturday: "",
        tenth_sunday: "",
        tenth_monday: "",
        tenth_tuesday: "",
        tenth_wednesday: "",
        tenth_thursday: "",
        tenth_friday: "",
        tenth_holiday: "",
        eleventh_saturday: "",
        eleventh_sunday: "",
        eleventh_monday: "",
        eleventh_tuesday: "",
        eleventh_wednesday: "",
        eleventh_thursday: "",
        eleventh_friday: "",
        eleventh_holiday: "",
        twelfth_saturday: "",
        twelfth_sunday: "",
        twelfth_monday: "",
        twelfth_tuesday: "",
        twelfth_wednesday: "",
        twelfth_thursday: "",
        twelfth_friday: "",
        twelfth_holiday: "",
    });

    const onWeekDaysChange = (event, index) => {
        const { name, value } = event.target;
        if (index === 0) {
            setTimes(oldTimes => {
                const copy = { ...oldTimes };
                Object.keys(copy).forEach(item => {
                    copy[item] = value;
                });
                return { ...oldTimes, ...copy };
            });
        } else {
            setTimes(oldTimes => ({ ...oldTimes, [name]: value }));
        }
    };

    //tags
    const KeyCodes = {
        comma: 188,
        enter: 13,
    };

    const delimiters = [KeyCodes.enter];

    const [tags, setTags] = useState([]);

    const handleDelete = i => {
        setTags(tags.filter((tag, index) => index !== i));
    };

    const handleAddition = tag => {
        setTags([...tags, tag]);
    };

    //upload file
    const [selectedFiles, setSelectedFiles] = useState([]);
    const handleFileChange = async e => {
        if (e.target.files) {
            const name = e.target.name;
            const file = e.target.files[0];

            setSelectedFiles(files => {
                const objectUrl = URL.createObjectURL(file);
                return [...files, { [name]: file, image: objectUrl }];
            });

            let data = new FormData();
            data.append("photo", file);
            data.append("alt", "");
            data.append("caption", "");

            try {
                const response = await axios.post(`${BASE_URL}/g5znsh6vtyic3w5/location/info/`, data, {
                    params: {
                        pk: locationInformation?.id,
                        action: "addImage",
                    },
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
                if (response.status === 200) {
                    getLocationInformation();
                }
            } catch (error) {
                getLocationInformation();
            }
        }
    };

    //remove file
    const removeFile = async id => {
        // const filesCopy = [...selectedFiles]
        // setSelectedFiles(filesCopy.splice(index, 1));
        let data = new FormData();
        data.append("image_id", id);
        const response = await axios.delete(`${BASE_URL}/g5znsh6vtyic3w5/location/info/`, {
            data,
            params: {
                pk: locationInformation?.id,
                action: "removeImage",
            },
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        setSelectedFiles(locationInformation?.images);
        getLocationInformation();
    };

    const intersection = (o1, o2) => {
        return Object.keys(o1).filter({}.hasOwnProperty.bind(o2));
    };

    // get location information
    useEffect(() => {
        if (isEditing && locationInformation) {
            setBaseInformation(values => {
                const result = {};
                const commonKeys = intersection(locationInformation, values);
                commonKeys.forEach(key => {
                    result[key] = locationInformation[key];
                });
                return result;
            });
            setSelectedCategory(categoryList?.find(item => item.value === locationInformation.category));
            setChecked(values => {
                const result = {};
                const commonKeys = intersection(locationInformation, values);
                commonKeys.forEach(key => {
                    result[key] = locationInformation[key];
                });
                return result;
            });
            setTimes(values => {
                const result = {};
                const commonKeys = intersection(locationInformation, values);
                commonKeys.forEach(key => {
                    result[key] = locationInformation[key];
                });
                return result;
            });
            if (locationInformation?.tags) {
                const tag = locationInformation?.tags;
                const tagList = tag?.split("،");
                setTags(tagList.map(tagItem => ({ id: tagItem, text: tagItem })));
            }
            setSelectedFiles(locationInformation.images);
        }
    }, [locationInformation, categoryList, searchParams]);

    //checkbox
    const [checked, setChecked] = useState({ family_suitable: false, child_suitable: false, man_only: false, woman_only: false });
    const handleCheckedChange = event => {
        const name = event.target.name;
        const value = event.target.checked;
        setChecked(values => ({ ...values, [name]: value }));
    };

    //add & edit location
    const submitLocationAdd = async event => {
        event.preventDefault();
        //checking the validity of the form
        const { isValid } = validateForm({ baseInformation, errors, forceTouchErrors: true });
        if (!isValid) return toast.error("عملیات ثبت با خطا مواجه شد!", { toastId: "custom-id-yes" });
        if (!selectedCategory || !selectedProvince || !selectedCity || !selectedCategory || !times) {
        }

        const tagList = tags.length ? tags.map(tagItem => tagItem.id).join("،") : "";
        if (isEditing) {
            const payload = {
                ...times,
                ...baseInformation,
                ...checked,
                country: selectedCountry.value,
                province: selectedProvince?.value,
                city: selectedCity.value,
                category: selectedCategory.value,
                tags: tagList,
            };

            try {
                const response = await axios.patch(`${BASE_URL}/g5znsh6vtyic3w5/location/info/`, payload, {
                    params: {
                        pk: locationInformation?.id,
                        action: "updateLocation",
                    },
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
                if (response.status === 200) {
                    toast.success(response.data.message, { toastId: "custom-id-yes" });
                }
                getLocationInformation();
            } catch (error) {
                toast.error("درخواست با خطا مواجه شد", { toastId: "custom-id-yes" });
                getLocationInformation();
            }
        } else {
            let data = new FormData();
            data.append("name", baseInformation.name);
            data.append("english_name", baseInformation.english_name);
            data.append("category", selectedCategory?.id);
            data.append("country", selectedCountry?.id);
            !!selectedProvince && data.append("province", selectedProvince?.id);
            data.append("city", selectedCity?.id);
            data.append("address", baseInformation.address);
            data.append("location", baseInformation.location);
            data.append("tags", tagList);
            data.append("text", baseInformation.text);
            data.append("description", baseInformation.description);
            data.append("extra_time", baseInformation.extra_time);
            data.append("extra_energy", baseInformation.extra_energy);
            data.append("family_suitable", checked.family_suitable);
            data.append("child_suitable", checked.child_suitable);
            data.append("man_only", checked.man_only);
            data.append("woman_only", checked.woman_only);
            data.append("first_saturday", times.first_saturday);
            data.append("first_sunday", times.first_sunday);
            data.append("first_monday", times.first_monday);
            data.append("first_tuesday", times.first_tuesday);
            data.append("first_wednesday", times.first_wednesday);
            data.append("first_thursday", times.first_thursday);
            data.append("first_friday", times.first_friday);
            data.append("first_holiday", times.first_holiday);
            data.append("second_saturday", times.second_saturday);
            data.append("second_sunday", times.second_sunday);
            data.append("second_monday", times.second_monday);
            data.append("second_tuesday", times.second_tuesday);
            data.append("second_wednesday", times.second_wednesday);
            data.append("second_thursday", times.second_thursday);
            data.append("second_friday", times.second_friday);
            data.append("second_holiday", times.second_holiday);
            data.append("third_saturday", times.third_saturday);
            data.append("third_sunday", times.third_sunday);
            data.append("third_monday", times.third_monday);
            data.append("third_tuesday", times.third_tuesday);
            data.append("third_wednesday", times.third_wednesday);
            data.append("third_thursday", times.third_thursday);
            data.append("third_friday", times.third_friday);
            data.append("third_holiday", times.third_holiday);
            data.append("forth_saturday", times.forth_saturday);
            data.append("forth_sunday", times.forth_sunday);
            data.append("forth_monday", times.forth_monday);
            data.append("forth_tuesday", times.forth_tuesday);
            data.append("forth_wednesday", times.forth_wednesday);
            data.append("forth_thursday", times.forth_thursday);
            data.append("forth_friday", times.forth_friday);
            data.append("forth_holiday", times.forth_holiday);
            data.append("fifth_saturday", times.fifth_saturday);
            data.append("fifth_sunday", times.fifth_sunday);
            data.append("fifth_monday", times.fifth_monday);
            data.append("fifth_tuesday", times.fifth_tuesday);
            data.append("fifth_wednesday", times.fifth_wednesday);
            data.append("fifth_thursday", times.fifth_thursday);
            data.append("fifth_friday", times.fifth_friday);
            data.append("fifth_holiday", times.fifth_holiday);
            data.append("sixth_saturday", times.sixth_saturday);
            data.append("sixth_sunday", times.sixth_sunday);
            data.append("sixth_monday", times.sixth_monday);
            data.append("sixth_tuesday", times.sixth_tuesday);
            data.append("sixth_wednesday", times.sixth_wednesday);
            data.append("sixth_thursday", times.sixth_thursday);
            data.append("sixth_friday", times.sixth_friday);
            data.append("sixth_holiday", times.sixth_holiday);
            data.append("seventh_saturday", times.seventh_saturday);
            data.append("seventh_sunday", times.seventh_sunday);
            data.append("seventh_monday", times.seventh_monday);
            data.append("seventh_tuesday", times.seventh_tuesday);
            data.append("seventh_wednesday", times.seventh_wednesday);
            data.append("seventh_thursday", times.seventh_thursday);
            data.append("seventh_friday", times.seventh_friday);
            data.append("seventh_holiday", times.seventh_holiday);
            data.append("eighth_saturday", times.eighth_saturday);
            data.append("eighth_sunday", times.eighth_sunday);
            data.append("eighth_monday", times.eighth_monday);
            data.append("eighth_tuesday", times.eighth_tuesday);
            data.append("eighth_wednesday", times.eighth_wednesday);
            data.append("eighth_thursday", times.eighth_thursday);
            data.append("eighth_friday", times.eighth_friday);
            data.append("eighth_holiday", times.eighth_holiday);
            data.append("ninth_saturday", times.ninth_saturday);
            data.append("ninth_sunday", times.ninth_sunday);
            data.append("ninth_monday", times.ninth_monday);
            data.append("ninth_tuesday", times.ninth_tuesday);
            data.append("ninth_wednesday", times.ninth_wednesday);
            data.append("ninth_thursday", times.ninth_thursday);
            data.append("ninth_friday", times.ninth_friday);
            data.append("ninth_holiday", times.ninth_holiday);
            data.append("tenth_saturday", times.tenth_saturday);
            data.append("tenth_sunday", times.tenth_sunday);
            data.append("tenth_monday", times.tenth_monday);
            data.append("tenth_tuesday", times.tenth_tuesday);
            data.append("tenth_wednesday", times.tenth_wednesday);
            data.append("tenth_thursday", times.tenth_thursday);
            data.append("tenth_friday", times.tenth_friday);
            data.append("tenth_holiday", times.tenth_holiday);
            data.append("eleventh_saturday", times.eleventh_saturday);
            data.append("eleventh_sunday", times.eleventh_sunday);
            data.append("eleventh_monday", times.eleventh_monday);
            data.append("eleventh_tuesday", times.eleventh_tuesday);
            data.append("eleventh_wednesday", times.eleventh_wednesday);
            data.append("eleventh_thursday", times.eleventh_thursday);
            data.append("eleventh_friday", times.eleventh_friday);
            data.append("eleventh_holiday", times.eleventh_holiday);
            data.append("twelfth_saturday", times.twelfth_saturday);
            data.append("twelfth_sunday", times.twelfth_sunday);
            data.append("twelfth_monday", times.twelfth_monday);
            data.append("twelfth_tuesday", times.twelfth_tuesday);
            data.append("twelfth_wednesday", times.twelfth_wednesday);
            data.append("twelfth_thursday", times.twelfth_thursday);
            data.append("twelfth_friday", times.twelfth_friday);
            data.append("twelfth_holiday", times.twelfth_holiday);
            try {
                const response = await axios.post(`${BASE_URL}/g5znsh6vtyic3w5/location/info/`, data, {
                    params: {
                        pk: 0,
                        action: "addLocation",
                    },
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
                if (response.status === 200) {
                    toast.success(response.data.message, { toastId: "custom-id-yes" });
                    navigate(`/${locale}/admin-panel/locations-managment`);
                }
            } catch (error) {
                return toast.error("درخواست با خطا مواجه شد", { toastId: "custom-id-yes" });
            }
        }
    };

    const goToAdminLocation = () => {
        navigate(`/${locale}/admin-panel/locations-managment`);
    };

    const nextLocation = idCurrent => {
        const id = idCurrent + 1;
        setSearchParams({ id: id, isEditing: true });
        window.location.reload(false);
    };
    const previousLocation = idCurrent => {
        const id = idCurrent - 1;
        setSearchParams({ id: id, isEditing: true });
    };
    const goToPointPage = (id, name) => {
        const params = { id: id, name: name };
        navigate({
            pathname: `/${locale}/admin-panel/location-point`,
            search: `?${createSearchParams(params)}`,
        });
    };

    return (
        <Grid className="location-add" container item xs={12} rowGap={3}>
            <ToastContainer rtl={true} theme="colored"></ToastContainer>
            <Button variant="outlined" color="error" onClick={goToAdminLocation}>
                بستن
            </Button>
            <Grid
                className="location-add__form"
                component="form"
                onSubmit={submitLocationAdd}
                container
                item
                xs={12}
                rowGap={2}
                justifyContent="space-between"
            >
                <Grid item xs={12}>
                    <h3>اطلاعات اصلی</h3>
                </Grid>
                <Grid container item xs={5.8} justifyContent="space-between" alignItems="center">
                    <Grid item xs={4}>
                        <label className="location-add__text-field">نام فارسی لوکیشن</label>
                    </Grid>
                    <Grid className="formGroup" item xs={8}>
                        <TextField
                            id="outlined-basic"
                            className={clsx("form__input", errors.name.dirty && errors.name.error && "formFieldError")}
                            fullWidth
                            type="text"
                            aria-label="name field"
                            name="name"
                            value={baseInformation.name}
                            onChange={handleChange}
                            onBlur={onBlurField}
                            dir="rtl"
                        />
                        {errors.name.dirty && errors.name.error ? <p className="formFieldErrorMessage">{errors.name.message}</p> : null}
                    </Grid>
                </Grid>
                <Grid container item xs={5.8} justifyContent="space-between" alignItems="center">
                    <Grid item xs={4}>
                        <label className="location-add__text-field">نام انگلیسی لوکیشن</label>
                    </Grid>
                    <Grid className="formGroup" item xs={8}>
                        <TextField
                            id="outlined-basic"
                            className={clsx("form__input", errors.english_name?.dirty && errors.english_name?.error && "formFieldError")}
                            fullWidth
                            type="text"
                            aria-label="english_name field"
                            name="english_name"
                            value={baseInformation.english_name}
                            onChange={handleChange}
                            onBlur={onBlurField}
                            dir="rtl"
                        />
                        {errors.english_name?.dirty && errors.english_name?.error ? (
                            <p className="formFieldErrorMessage">{errors.english_name?.message}</p>
                        ) : null}
                    </Grid>
                </Grid>
                <Grid container item xs={5.8} justifyContent="space-between" alignItems="center">
                    <Grid item xs={4}>
                        <label className="location-add__text-field">کشور</label>
                    </Grid>
                    <Grid item xs={8}>
                        <BaseSelect
                            value={selectedCountry}
                            setValue={setSelectedCountry}
                            placeholder="انتخاب کشور"
                            isMulti={false}
                            options={countryList}
                            search={true}
                            dropdownIndicator={true}
                        ></BaseSelect>
                    </Grid>
                </Grid>
                <Grid container item xs={5.8} justifyContent="space-between" alignItems="center">
                    <Grid item xs={4}>
                        <label className="location-add__text-field">استان</label>
                    </Grid>
                    <Grid item xs={8}>
                        <BaseSelect
                            value={selectedProvince}
                            setValue={setSelectedProvince}
                            placeholder="انتخاب استان"
                            isMulti={false}
                            options={provinceList}
                            search={true}
                            dropdownIndicator={true}
                        ></BaseSelect>
                    </Grid>
                </Grid>
                <Grid container item xs={5.8} justifyContent="space-between" alignItems="center">
                    <Grid item xs={4}>
                        <label className="location-add__text-field">شهر</label>
                    </Grid>
                    <Grid item xs={8}>
                        <BaseSelect
                            value={selectedCity}
                            setValue={setSelectedCity}
                            placeholder="انتخاب شهر"
                            isMulti={false}
                            options={cityList}
                            search={true}
                            dropdownIndicator={true}
                        ></BaseSelect>
                    </Grid>
                </Grid>
                <Grid container item xs={5.8} justifyContent="space-between" alignItems="center">
                    <Grid item xs={4}>
                        <label className="location-add__text-field">دسته بندی</label>
                    </Grid>
                    <Grid item xs={8}>
                        <BaseSelect
                            value={selectedCategory}
                            setValue={setSelectedCategory}
                            placeholder="دسته بندی"
                            isMulti={false}
                            options={categoryList}
                            search={true}
                            dropdownIndicator={true}
                        ></BaseSelect>
                    </Grid>
                </Grid>
                <Grid container item xs={12} justifyContent="space-between" alignItems="center">
                    <Grid item xs={2}>
                        <label className="location-add__text-field">آدرس</label>
                    </Grid>
                    <Grid className="formGroup" item xs={10}>
                        <TextField
                            id="outlined-basic"
                            className={clsx("form__input", errors.address.dirty && errors.address.error && "formFieldError")}
                            fullWidth
                            type="text"
                            aria-label="address field"
                            name="address"
                            value={baseInformation.address}
                            onChange={handleChange}
                            onBlur={onBlurField}
                            dir="rtl"
                        />
                        {errors.address.dirty && errors.address.error ? <p className="formFieldErrorMessage">{errors.address.message}</p> : null}
                    </Grid>
                </Grid>

                <Grid container item xs={5.8} justifyContent="space-between" alignItems="center">
                    <Grid item xs={4}>
                        <label className="location-add__text-field">زمان بازدید</label>
                    </Grid>
                    <Grid item xs={8}>
                        <TextField
                            id="outlined-multiline-static"
                            name="avg_mins"
                            value={baseInformation.avg_mins + "دقیقه"}
                            onChange={handleChange}
                            disabled
                            fullWidth
                            dir="rtl"
                        />
                    </Grid>
                </Grid>
                <Grid container item xs={5.8} justifyContent="space-between" alignItems="center">
                    <Grid item xs={4}>
                        <label className="location-add__text-field">کاهش یا افزایش زمان بازدید</label>
                    </Grid>
                    <Grid item xs={8}>
                        <TextField
                            id="outlined-multiline-static"
                            name="extra_time"
                            value={baseInformation.extra_time}
                            onChange={handleChange}
                            placeholder="مثال: 40 یا 40-"
                            fullWidth
                            dir="rtl"
                        />
                    </Grid>
                </Grid>

                <Grid container item xs={5.8} justifyContent="space-between" alignItems="center">
                    <Grid item xs={4}>
                        <label className="location-add__text-field">انرژی بازدید</label>
                    </Grid>
                    <Grid item xs={8}>
                        <TextField
                            id="outlined-multiline-static"
                            name="energy"
                            value={baseInformation.energy + "واحد"}
                            onChange={handleChange}
                            disabled
                            fullWidth
                            dir="rtl"
                        />
                    </Grid>
                </Grid>
                <Grid container item xs={5.8} justifyContent="space-between" alignItems="center">
                    <Grid item xs={4}>
                        <label className="location-add__text-field">کاهش یا افزایش انرژی بازدید</label>
                    </Grid>
                    <Grid item xs={8}>
                        <TextField
                            id="outlined-multiline-static"
                            name="extra_energy"
                            value={baseInformation.extra_energy}
                            onChange={handleChange}
                            fullWidth
                            dir="rtl"
                        />
                    </Grid>
                </Grid>

                <Grid container item xs={10} justifyContent="space-between" alignItems="center">
                    <Grid item xs={4}>
                        <label className="location-add__text-field">مناسب برای:</label>
                    </Grid>
                    <label>بزرگسال</label>
                    <Checkbox
                        name="family_suitable"
                        checked={checked.family_suitable}
                        onChange={handleCheckedChange}
                        inputProps={{ "aria-label": "controlled" }}
                    />
                    <label>بچه</label>
                    <Checkbox
                        name="child_suitable"
                        checked={checked.child_suitable}
                        onChange={handleCheckedChange}
                        inputProps={{ "aria-label": "controlled" }}
                    />
                    <label>مرد</label>
                    <Checkbox name="man_only" checked={checked.man_only} onChange={handleCheckedChange} inputProps={{ "aria-label": "controlled" }} />
                    <label>زن</label>
                    <Checkbox
                        name="woman_only"
                        checked={checked.woman_only}
                        onChange={handleCheckedChange}
                        inputProps={{ "aria-label": "controlled" }}
                    />
                    {/* <Grid item xs={8}><TextField id="outlined-multiline-static" name='extra_energy' value={baseInformation.extra_energy} onChange={handleChange} fullWidth dir="rtl" /></Grid> */}
                </Grid>

                <Grid container item xs={5.8} justifyContent="space-between" alignItems="center">
                    <Grid item xs={4}>
                        <label className="location-add__text-field">لوکیشن</label>
                    </Grid>
                    <Grid className="formGroup" item xs={8}>
                        <TextField
                            id="outlined-multiline-static"
                            className={clsx("form__input", errors.location.dirty && errors.location.error && "formFieldError")}
                            fullWidth
                            name="location"
                            value={baseInformation.location}
                            type="text"
                            aria-label="location field"
                            onChange={handleChange}
                            onBlur={onBlurField}
                            dir="rtl"
                        />
                        {errors.location.dirty && errors.location.error ? <p className="formFieldErrorMessage">{errors.location.message}</p> : null}
                    </Grid>
                </Grid>

                <Grid container item xs={5.8} justifyContent="space-between" alignItems="center">
                    <Grid item xs={4}>
                        <label className="location-add__text-field">برچسب ها</label>
                    </Grid>
                    <Grid item xs={8}>
                        <ReactTags
                            tags={tags}
                            delimiters={delimiters}
                            handleDelete={handleDelete}
                            handleAddition={handleAddition}
                            inputFieldPosition="bottom"
                        />
                    </Grid>
                </Grid>

                <Grid container item xs={5.8} justifyContent="space-between" alignItems="center">
                    <Grid item xs={4}>
                        <label className="location-add__text-field">توضیحات</label>
                    </Grid>
                    <Grid item xs={8}>
                        <TextField
                            id="outlined-multiline-static"
                            name="description"
                            value={baseInformation.description}
                            onChange={handleChange}
                            multiline
                            rows={5}
                            fullWidth
                        />
                    </Grid>
                </Grid>

                <Grid container item xs={12} justifyContent="space-between" alignItems="center">
                    <Grid item xs={2}>
                        <label className="location-add__text-field">درباره لوکیشن</label>
                    </Grid>
                    <Grid item xs={10}>
                        <TextField
                            id="outlined-multiline-static"
                            name="text"
                            value={baseInformation.text}
                            onChange={handleChange}
                            multiline
                            rows={10}
                            fullWidth
                        />
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <h3>ساعات بازدید</h3>
                </Grid>
                {Object.keys(times).map((timeKey, timeIndex) => {
                    const englishWeekDay = timeKey.split("_")[1];
                    if (timeIndex % 8 === 0) {
                        monthIndex++;
                        return (
                            <>
                                <Grid key={Math.random()} item xs={12}>
                                    <h5>{MONTH_NAMES[monthIndex - 1]}</h5>
                                </Grid>
                                <Grid container item xs={2.8} justifyContent="space-between" alignItems="center">
                                    <Grid item xs={4}>
                                        <label className="location-add__text-field">{weekDaysMap[englishWeekDay]}</label>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <TextField
                                            id="outlined-basic"
                                            name={timeKey}
                                            value={times[timeKey]}
                                            onChange={event => onWeekDaysChange(event, timeIndex)}
                                            fullWidth
                                            dir="rtl"
                                        />
                                    </Grid>
                                </Grid>
                            </>
                        );
                    } else {
                        return (
                            <Grid container item xs={2.8} justifyContent="space-between" alignItems="center">
                                <Grid item xs={4}>
                                    <label className="location-add__text-field">{weekDaysMap[englishWeekDay]}</label>
                                </Grid>
                                <Grid item xs={8}>
                                    <TextField
                                        id="outlined-basic"
                                        name={timeKey}
                                        value={times[timeKey]}
                                        onChange={event => onWeekDaysChange(event, timeIndex)}
                                        fullWidth
                                        dir="rtl"
                                    />
                                </Grid>
                            </Grid>
                        );
                    }
                })}

                <Grid container item xs={12} justifyContent="space-between" alignItems="center">
                    {isEditing ? (
                        <Grid container item xs={4} justifyContent="space-between">
                            <Grid item xs={3.8}>
                                <Button variant="contained" color="secondary" onClick={() => nextLocation(baseInformation?.id)} fullWidth>
                                    بعدی
                                </Button>
                            </Grid>
                            <Grid item xs={3.8}>
                                <Button variant="contained" color="secondary" onClick={() => previousLocation(baseInformation?.id)} fullWidth>
                                    قبلی
                                </Button>
                            </Grid>
                            <Grid item xs={3.8}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => goToPointPage(baseInformation?.id, baseInformation?.name)}
                                    fullWidth
                                >
                                    امتیازدهی
                                </Button>
                            </Grid>
                        </Grid>
                    ) : (
                        ""
                    )}
                    <Grid item xs={4}>
                        <Button variant="contained" type="submit" color="success" fullWidth>
                            ثبت
                        </Button>
                    </Grid>
                </Grid>
            </Grid>

            {isEditing ? (
                <Grid className="location-add__form" component="form" container item xs={12} rowGap={2} columnGap={1}>
                    <Grid item xs={12}>
                        <h3>تصاویر لوکیشن</h3>
                    </Grid>
                    {selectedFiles.map((file, fileIndex) => {
                        return (
                            <Grid
                                className="location-add__image-file"
                                key={Math.random()}
                                container
                                item
                                xs={2.8}
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <img src={"https://api.atripa.com" + file.image}></img>
                                {/* <img src={file.image}></img> */}
                                <span className="location-add__cancel" onClick={() => removeFile(file.id)}>
                                    <Icon icon="material-symbols:cancel" color="#ff6363" width="50" height="50" />
                                </span>
                                {/* {selectedFile.image && `${selectedFile.image.name}`} */}
                            </Grid>
                        );
                    })}
                    <Grid className="location-add__image-file" container item xs={2.8} justifyContent="center" alignItems="center">
                        <input id="logo" type="file" name="image" onChange={handleFileChange} />
                        <label htmlFor="logo">
                            <Icon icon="bx:image-add" color="#1aaba7" width="50" height="50" />
                        </label>
                    </Grid>
                </Grid>
            ) : (
                ""
            )}
        </Grid>
    );
}

export default LocationAdd;
